module.exports = __webpack_public_path__ + "img/row.ced85861.svg";